import React from "react";
import { Form, Input, Button, Card, DatePicker } from "antd";
import { connect } from "react-redux";
import { fetchTextbooks } from "../../../../store/actions/selfTextbookAction";

import {
  fetchCourse,
  createCourse,
  updateCourse,
  emptyCourse,
} from "../../../../store/actions/selfCourseAction";

import { MY_CONTENT_BASE_URL } from "../../../../constants/LookupConst";
import CircularProgress from "../../../../components/CircularProgress";
import { toast } from "react-toastify";
import moment from "moment";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import InputSelectAdd from "../../../../components/InputSelectAdd";
import "../mycontent.css";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

class ClassGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isTextbookInputVisible: false,
      isMainSubjectInputVisible: false,
      isSubSubjectInputVisible: false,
      textbookval: "",
      mainsubjectval: "",
      subsubjectval: "",
      textbooks: [],
      mainsubjectnames: [],
      subsubjectnames: [],
      professors: [],
      assignedtextbooks: [],
      // mainsubjectname: "",
      // subsubjectname: ""
    };
  }
  formRef = React.createRef();

  async componentDidMount() {
    const {
      match: { params },
      // lookupCoursePlanStatus,
      // lookupCourseYears,
      fetchCourse,
      // fetchLookups,
      // fetchCountries,
      // fetchTextbooks,
      // fetchDivisions,
      // fetchOrgTypes,
      // fetchSystems,
      // fetchDepartments,
      // fetchGenCoursePlans,
      // fetchCoursePlans,
      // fetchProfessors,
    } = this.props;
    // let lookupNames = [];
    // if (!(lookupCoursePlanStatus && lookupCoursePlanStatus.length)) {
    //   lookupNames.push("courseplanstatus");
    // }
    // if (!(lookupCourseYears && lookupCourseYears.length)) {
    //   lookupNames.push("courseyears");
    // }
    // fetchLookups({
    //   names: lookupNames,
    // });
    // fetchCountries();
    // if(params.id) {
    //   let textbooks = await selfLookupService.fetchSelfLookups({
    //     category: "textbook",parenttype: "course", parentid: params.id
    //   });
    //   let mainsubjectnames = await selfLookupService.fetchSelfLookups({
    //     category: "mainsubjectname",parenttype: "course"
    //   });
    //   let subsubjectnames = await selfLookupService.fetchSelfLookups({
    //     category: "subsubjectname",parenttype: "course"
    //   });
    //   this.setState({
    //     textbooks,
    //     mainsubjectnames,
    //     subsubjectnames
    //   })
    // }
    // fetchDivisions();
    // fetchOrgTypes();
    // fetchSystems();
    // fetchDepartments();
    // fetchGenCoursePlans();
    // fetchCoursePlans();
    // await fetchProfessors();
    if (params.id) {
      await fetchCourse(params.id);
    }
  }

  async componentWillUnmount() {
    this.props.emptyCourse();
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectedCourse } = this.props;
    if (
      prevProps.selectedCourse &&
      prevProps.selectedCourse._id !== selectedCourse._id
    ) {
      this.setState({
        professor: selectedCourse.professor,
        mainsubjectname: selectedCourse.mainsubjectname,
        subsubjectname: selectedCourse.subsubjectname,
        assignedtextbooks: selectedCourse.assignedtextbooks,
      });
    }
  }

  // enableUpdate = (record) => {

  //   setTimeout(() => {
  //   this.filterOrgTypesByCountry(record.country);
  //   this.filterSystemsByOrgType(record.orgType);
  //   this.filterDivisionBySystem(record.system);
  //   this.filterDepartmentsByDivision(record.division);
  //   this.filterGenericCourseNamesByDepartments(record.department);
  //   this.filterBlastCoursePlansByGenericCoursePlans(record.gencourseplanid);
  //   this.filterProfessors(record.mainprofessor)
  //     this.formRef.current.setFieldsValue({
  //       country: record.country,
  //       orgType: record.orgType,
  //       system: record.system,
  //       division: record.division,
  //       department: record.department,
  //       gencourseplanid: record.gencourseplanid,
  //       courseplanid: record.courseplanid,
  //       mainprofessor: record.mainprofessor,
  //     });
  //   }, 100);
  // };

  // filterOrgTypesByCountry = (val) => {
  //   const { org_types } = this.props;
  //   const copy_org_types = [...org_types];
  //   const filtered = copy_org_types.filter((ct) => ct.country._id === val);
  //   this.setState({
  //     filtered_org_types: filtered
  //   })
  // };

  // filterGenericCourseNamesByDepartments = (val) => {
  //   const { gen_course_names } = this.props;
  //   const copy_gen_course_names = [...gen_course_names];
  //   const filtered = copy_gen_course_names.filter((ct) => ct.department._id === val);
  //   this.setState({
  //     filtered_gen_course_names: filtered
  //   })
  // };
  // filterBlastCoursePlansByGenericCoursePlans = (val) => {
  //   const { blast_course_plans } = this.props;
  //   const copy_blast_course_plans = [...blast_course_plans];
  //   const filtered = copy_blast_course_plans.filter((ct) => ct.sourceunitid === val);
  //   this.setState({
  //     filtered_blast_course_plans: filtered
  //   })
  // };

  // filterSystemsByOrgType = (val) => {
  //   const { systems } = this.props;
  //   const copy_systems = [...systems];
  //   const filtered = copy_systems.filter((r) => r.orgType._id === val);
  //   this.setState({
  //     filtered_systems: filtered
  //   })
  // };

  // filterDivisionBySystem = (val) => {
  //   const { divisions } = this.props;
  //   const copy_divisions = [...divisions];
  //   const filtered = copy_divisions.filter((r) => r.system._id === val);
  //   this.setState({
  //     filtered_divisions: filtered
  //   })
  // };

  // filterDepartmentsByDivision = (val) => {
  //   const { departments } = this.props;
  //   const copy_departments = [...departments];
  //   const filtered = copy_departments.filter((r) => r.division._id === val);
  //   this.setState({
  //     filtered_departments: filtered
  //   })
  // };

  // filterProfessors = (val) => {
  //   const { professors } = this.props;
  //   const copy_professors = [...professors];
  //   const filtered = copy_professors.filter((ct) => ct._id !== val);
  //   this.setState({
  //     filtered_professors: filtered
  //   })
  // };

  // addLookupValue = async (category,categoryval) => {
  //   const { match: { params } }  = this.props;
  //   let selflookup = await selfLookupService.createSelfLookup({
  //     value: categoryval,
  //     category: category == "textbook" ? "texbook" : category,
  //     parenttype: "course",
  //     parentid: category == "textbook" && params.id ? params.id : undefined,
  //   });
  //   const { textbooks, mainsubjectnames, subsubjectnames } = this.state;
  //   if(category == "textbook") {
  //     this.setState({
  //       textbooks: [
  //         ...textbooks,{
  //           ...selflookup.data,
  //         }
  //       ],
  //       textbookval: "",
  //       isTextbookInputVisible: false
  //     })
  //   } else if(category == "mainsubjectname") {
  //     this.setState({
  //       mainsubjectnames: [
  //         ...mainsubjectnames,{
  //           ...selflookup.data,
  //         }
  //       ],
  //       mainsubjectval: "",
  //       isMainSubjectInputVisible: false
  //     })
  //   } else if(category == "subsubjectname") {
  //     this.setState({
  //       subsubjectnames: [
  //         ...subsubjectnames,{
  //           ...selflookup.data,
  //         }
  //       ],
  //       subsubjectname: "",
  //       isSubSubjectInputVisible: false
  //     })
  //   }
  //   if(params.id) {

  //   }
  // }

  onTextbookItemAdd = (id) => {
    const { textbooks } = this.state;
    this.setState({
      textbooks: [...textbooks, id],
    });
  };

  // onMainSubjectNameItemAdd = (id) => {
  //   const { mainsubjectnames } = this.state;
  //   this.setState({
  //     mainsubjectnames: [...mainsubjectnames,id]
  //   })
  // }
  // onProfessorItemAdd = (id) => {
  //   const { professors } = this.state;
  //   this.setState({
  //     professors: [...professors,id]
  //   })
  // }

  onSubSubjectNameItemAdd = (id) => {
    const { subsubjectnames } = this.state;
    this.setState({
      subsubjectnames: [...subsubjectnames, id],
    });
  };

  onTextbooksChange = (data) => {
    this.setState({ assignedtextbooks: data });
  };
  onProfessorChange = (data) => {
    this.setState({ professor: data });
  };
  onMainSubjectNameChange = (data) => {
    this.setState({ mainsubjectname: data });
  };
  onSubSubjectNameChange = (data) => {
    this.setState({ subsubjectname: data });
  };

  render() {
    const onFinish = async (values) => {
      const { history } = this.props;
      if (!params.id) {
        await this.props.createCourse(
          {
            ...values,
            assignedtextbooks,
            mainsubjectname,
            subsubjectname,
            textbooks,
            professor,
          },
          (res) => {
            if (res.success) {
              toast.success(res.message);
            } else {
              toast.error(res.message);
            }
          }
        );
      } else {
        await this.props.updateCourse(
          {
            ...values,
            assignedtextbooks,
            mainsubjectname,
            subsubjectname,
            professor,
          },
          params.id,
          (res) => {
            if (res.success) {
              toast.success(res.message);
            } else {
              toast.error(res.message);
            }
          }
        );
      }
      history.push(`${MY_CONTENT_BASE_URL}?tab=course`);
    };

    const {
      // filtered_departments,
      // filtered_divisions,
      // filtered_gen_course_names,
      // filtered_org_types,
      // filtered_systems,
      // filtered_blast_course_plans,
      // filtered_professors,
      // isTextbookInputVisible,
      // textbookval,
      // isMainSubjectInputVisible,
      // mainsubjectval,
      // isSubSubjectInputVisible,
      // subsubjectval,
      textbooks,
      assignedtextbooks,
      mainsubjectname,
      subsubjectname,
      professor,
    } = this.state;
    const {
      // lookupCourseYears,
      // location: { search },
      match: { params },
      selectedCourse,
      loading,
      // countries,
      // professors,
    } = this.props;
    const data = selectedCourse;
    if (!(data && data._id) && params.id) {
      return (
        <div className="gx-loader-view">
          <CircularProgress />
        </div>
      );
    }
    return (
      <Card className="gx-card blast-mc" title="Study Courses">
        {!loading ? (
          <Form
            ref={this.formRef}
            {...formItemLayout}
            name="register"
            onFinish={onFinish}
            scrollToFirstError
          >
            <Form.Item
              name="coursename"
              label="Course Name"
              initialValue={data.coursename}
              rules={[
                {
                  type: "string",
                  message: "The input is not valid course name",
                },
                {
                  required: true,
                  message: "Please input course name",
                },
              ]}
            >
              <Input
                placeholder="Please enter course name"
                // value={data.coursename}
              />
            </Form.Item>
            {/* <Form.Item
            name="professors"
            label="Professors"
            initialValue={data.professors}
            // rules={[
            //   {
            //     required: true,
            //     message: "Please slect atleast one professor",
            //   },
            // ]}
          >
            <Select
              mode="multiple"
              placeholder="Please select professors for this course"
            >
              {professors &&
                professors.length &&
                professors.map((ele) => (
                  <Option key={ele._id} value={ele._id}>{ele.firstname+" "+ele.lastname}</Option>
              ))}
            </Select>
          </Form.Item> */}
            {/* <Form.Item
            name="assignedtextbooks"
            label="Assigned Textbooks"
            // initialValue={assignedTextbooksInitialValue}
          >
            
              <InputGroup compact >
              <Select
              mode="multiple"
              className="gx-w-90 textbook-multiple"
              placeholder="Please assign textbooks to study plan"
              onChange={this.onTextbooksChange}
            >
              {textbooks.map((ele) => (
                <Option key={ele._id}  value={ele._id}>{ele.value}</Option>
              ))}
            </Select>
            <Button onClick={() => this.setState({ isTextbookInputVisible: !isTextbookInputVisible})}><PlusCircleOutlined/></Button>
          </InputGroup>
          {isTextbookInputVisible && <Input value={textbookval} addonAfter={<CheckCircleOutlined onClick={() => this.addLookupValue("textbook",textbookval)}/>} onChange={(e) => this.setState({ textbookval: e.target.value })}/>}
          </Form.Item> */}
            <InputSelectAdd
              category={"professor"}
              placeholder={`Please assign professor to course`}
              onChange={this.onProfessorChange}
              onItemAdd={this.onProfessorItemAdd}
              parenttype={"course"}
              name={"professor"}
              label={"Professor"}
              initialValue={this.state.professor}
            />
            <InputSelectAdd
              category={"mainsubjectname"}
              placeholder={`Please assign main subject name`}
              onChange={this.onMainSubjectNameChange}
              // onItemAdd={this.onMainSubjectNameItemAdd}
              parenttype={"course"}
              name={"mainsubjectname"}
              label={"Main Subject Name"}
              initialValue={this.state.mainsubjectname}
            />
            <InputSelectAdd
              category={"subsubjectname"}
              placeholder={`Please assign sub subject name`}
              onChange={this.onSubSubjectNameChange}
              // onItemAdd={this.onSubSubjectNameItemAdd}
              parenttype={"course"}
              name={"subsubjectname"}
              label={"Sub Subject Name"}
              initialValue={this.state.subsubjectname}
            />
            <InputSelectAdd
              category={"textbook"}
              parentid={params.id}
              placeholder={`Please assign textbooks to course`}
              isMultiple={true}
              onChange={this.onTextbooksChange}
              onItemAdd={this.onTextbookItemAdd}
              parenttype={"course"}
              name={"assignedtextbooks"}
              label={"Assigned Textbooks"}
              initialValue={this.state.assignedtextbooks}
            />
            {/* <Form.Item
            name="orgType"
            label="Organisation Type"
            rules={[
              {
                required: true,
                message: "Please select Organisation Type!",
              },
            ]}
          >
            <Select
              placeholder="Select Organisation Type"
              onChange={(val) => {
                this.filterSystemsByOrgType(val);
                this.formRef.current.setFieldsValue({
                  system: null,
                  division: null,
                  department: null,
                  gencourseplanid: null,
                  courseplanid: null
                });
              }}
            >
              {filtered_org_types.map((record) => {
                return (
                  <Option key={record._id} value={record._id}>
                    {record.unitname}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item
            name="system"
            label="College Univesity Name"
            rules={[
              {
                required: true,
                message: "Please select System!",
              },
            ]}
          >
            <Select
              placeholder="Select System"
              onChange={(val) => {
                this.filterDivisionBySystem(val);
                this.formRef.current.setFieldsValue({
                  division: null,
                  department: null,
                  gencourseplanid: null,
                  courseplanid: null
                });
              }}
            >
              {filtered_systems.map((record) => {
                return (
                  <Option key={record._id} value={record._id}>
                    {record.unitname}
                  </Option>
                );
              })}
            </Select>
          </Form.Item> */}

            {/* {!isClone && <Form.Item
            name="division"
            label="Division"
            rules={[
              {
                required: true,
                message: "Please select Division!",
              },
            ]}
          >
            <Select
              placeholder="Select Division"
              onChange={(val) => {
                this.filterDepartmentsByDivision(val);
                this.formRef.current.setFieldsValue({
                  department: null,
                  gencourseplanid: null,
                  courseplanid: null
                });
              }}
            >
              {filtered_divisions.map((record) => {
                return (
                  <Option key={record._id} value={record._id}>
                    {record.unitname}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>} */}
            {/* <Form.Item
            name="testdate"
            label="Test Date"
            // rules={[
            //   {
            //     required: true,
            //     message: "Please select test date!",
            //   },
            // ]}
            initialValue={data.testdate ? moment(data.testdate) : moment()}
          >
            <DatePicker
              placeholder="Please enter a date you want to start test"
              // value={scheduledAt}
              format="MM/DD/YYYY"
              className="gx-w-100"
              // onChange={this.onDateChange}
            />
          </Form.Item> */}
            <Form.Item
              name="startdate"
              label="Course start Date"
              initialValue={data.startdate ? moment(data.startdate) : moment()}
              // rules={[
              //   {
              //     required: true,
              //     message: "Please select start date!",
              //   },
              // ]}
            >
              <DatePicker
                placeholder="Please enter a course start date"
                // value={scheduledAt}
                format="MM/DD/YYYY"
                className="gx-w-100"
                // onChange={this.onDateChange}
              />
            </Form.Item>
            <Form.Item
              name="enddate"
              label="Course end Date"
              initialValue={data.enddate ? moment(data.enddate) : ""}
              // rules={[
              //   {
              //     required: true,
              //     message: "Please select end date!",
              //   },
              // ]}
            >
              <DatePicker
                placeholder="Please enter a course end date"
                // value={scheduledAt}
                format="MM/DD/YYYY"
                className="gx-w-100"
                // onChange={this.onDateChange}
              />
            </Form.Item>
            <Form.Item
              name="additionalinformation"
              label="Additional Information"
              initialValue={data.additionalinformation}
              rules={[
                {
                  type: "string",
                  message: "The input is not valid class name",
                },
              ]}
            >
              <Input
                placeholder="Please enter additional information"
                value={data.additionalinformation}
              />
            </Form.Item>
            <Form.List
              name="testdates"
              initialValue={
                data.testdates && data.testdates.length
                  ? data.testdates.map((ele) => moment(ele))
                  : []
              }
              // rules={[
              //   {
              //     validator: async (_, testdates) => {
              //       if (!testdates || testdates.length < 1) {
              //         return Promise.reject(
              //           new Error("Please add at least one test date")
              //         );
              //       }
              //     },
              //   },
              // ]}
            >
              {(fields, { add, remove }, { errors }) => (
                <>
                  {fields.map((field, index) => (
                    <Form.Item
                      label={`Test Date ${index + 1}: `}
                      required={false}
                      key={field.key}
                    >
                      <Form.Item
                        {...field}
                        validateTrigger={["onChange", "onBlur"]}
                        rules={[
                          {
                            required: true,
                            message:
                              "Please add test date or delete this field.",
                          },
                        ]}
                        noStyle
                      >
                        <DatePicker format="MM/DD/YYYY"></DatePicker>
                      </Form.Item>
                      {fields.length >= 1 ? (
                        <MinusCircleOutlined
                          style={{ marginLeft: "10px" }}
                          className="dynamic-delete-button"
                          onClick={() => remove(field.name)}
                        />
                      ) : null}
                    </Form.Item>
                  ))}

                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                    >
                      Add Test Date{" "}
                    </Button>

                    <Form.ErrorList errors={errors} />
                  </Form.Item>
                </>
              )}
            </Form.List>

            <Form.Item {...tailFormItemLayout}>
              <Button type="primary" htmlType="submit">
                {!!params.id ? "Update" : "Create"}
              </Button>
            </Form.Item>
          </Form>
        ) : (
          <div className="gx-loader-view">
            <CircularProgress />
          </div>
        )}
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  // lookupCoursePlanStatus: state.lookup.courseplanstatus,
  // lookupCourseYears: state.lookup.courseyears,
  textbooks: state.selftextbooks.dataList,
  selectedCourse: state.selfcourses.selectedCourse,
  loading: state.courseplans.loading,
  countries: state.blast_units.countries,
  org_types: state.blast_units.org_types,
  systems: state.blast_units.systems,
  divisions: state.blast_units.divisions,
  departments: state.blast_units.departments,
  gen_course_names: state.blast_units.gen_course_names,
  blast_course_plans: state.courseplans.dataList,
  professors: state.user.professors,
});

const mapDispatchToProps = {
  // fetchLookups,
  fetchTextbooks,
  createCourse,
  fetchCourse,
  updateCourse,
  emptyCourse,
  // fetchCountries,
  // fetchSystems,
  // fetchOrgTypes,
  // fetchDivisions,
  // fetchDepartments,
  // fetchGenCoursePlans,
  // fetchCoursePlans,
  // fetchProfessors,
};

export default connect(mapStateToProps, mapDispatchToProps)(ClassGroup);
